/**
 * Which page of a RESULT's own page list a container page is.
 *
 * `document_chunks.page_number` — and `extracted_data[].page_number` with it —
 * is 1-based within the owning result's `pages` array, not the container's. A
 * template-pool run handed pages 3-4 stores them as 1-2, so a surface that
 * renders one page and hands the viewer the container-wide number attaches the
 * highlights to a page the result does not have, and nothing is outlined at all.
 *
 * The same conversion the other way round (viewer index → stored page number,
 * for persisting a hand-drawn highlight) is `resultLocalPageNumber`; this is the
 * form for a caller that holds a page ROW rather than a viewer offset, and it
 * mirrors `ownerPageNumber` in `buildContainerPageRows`.
 *
 * `fallback` is the page's 1-based position in the container — correct for the
 * normal case where a result carries the whole container list, and the honest
 * guess for an `uncovered` row whose owner is only a handle.
 */
export function resultLocalPageOf(
  result: { pages?: { id: number }[] },
  pageId: number,
  fallback: number
): number {
  const index = (result.pages ?? []).findIndex((page) => page.id === pageId);

  return index >= 0 ? index + 1 : fallback;
}
